import { HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { HttpService } from "src/app/session/services/http.service";
import { environment } from "src/environments/environment";
import { Item } from "../model/item";

@Injectable({
  providedIn: "root",
})
export class ImportItemsService {
  constructor(private httpService: HttpService) {}

  importItems(formId: string, file: File): Promise<Item[]> {
    const formData = this.createFormData(formId, file);
    return this.httpService
      .post(`${environment.webApiUrl}/api/ImportItems`, formData, {
        withCredentials: true,
      })
      .pipe(
        map((items: Item[]) => {
          //set each item id as null, cause all of them are new
          items.forEach((item) => (item.id = null));
          return items;
        }),
      )
      .toPromise();
  }
  private createFormData(formId: string, file: File) {
    const formData = new FormData();
    formData.set("formId", formId);
    formData.set("file", file);
    return formData;
  }
}
